import type { ReactNode } from 'react'

export function PageHero({ eyebrow, title, text, mobileText, children }: { eyebrow: string; title: ReactNode; text: string; mobileText?: string; children?: ReactNode }) {
  return <section className={`page-hero section-pad${mobileText ? ' has-mobile-summary' : ''}`}>
    <p className="eyebrow">{eyebrow}</p>
    <h1>{title}</h1>
    <p className="page-hero-lede">{text}</p>
    {mobileText && <p className="page-hero-mobile-lede">{mobileText}</p>}
    {children && <div className="page-hero-extra">{children}</div>}
  </section>
}
